// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"78":"95231f37","278":"800cb0ae","506":"b2e4c382","655":"7a511d08","876":"33bea320"}[chunkId] + ".css";
};